import { Menu, MenuListProps, PopoverProps } from '@mui/material';
import { RefObject } from 'react';
import { menuStyles } from './MobileMenu.styles';
interface IMobileMenu {
  open: PopoverProps['open'];
  onClose: PopoverProps['onClose'];
  children: React.ReactNode;
  appBarRef?: RefObject<HTMLDivElement>;
}
export default function MobileMenu({
  open,
  onClose,
  children,
  appBarRef
}: Readonly<IMobileMenu>) {
  return <Menu open={open} anchorEl={appBarRef?.current} onClose={onClose} marginThreshold={0} transitionDuration={1} sx={menuStyles}
  // MenuListProps type doesn't include data-testid despite the underlying ul supporting it
  MenuListProps={{
    'data-testid': 'header_with_location_nav_mobile_menu_list'
  } as Partial<MenuListProps>} data-sentry-element="Menu" data-sentry-component="MobileMenu" data-sentry-source-file="MobileMenu.tsx">
			{children}
		</Menu>;
}